<template>
  <div
    class="price__plan-card flex flex--column"
    :class="{ active: card.popular }"
    @click="handleCloseSelect"
  >
    <template v-if="media >= 991">
      <div class="price__plan-title">
        {{ card.title }}
        <div class="price__plan-popular" v-if="card.title === 'Business'">
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.63262 0.853097C6.77145 0.530712 7.22855 0.530711 7.36738 0.853097L8.79873 4.17682C8.85664 4.31129 8.98338 4.40338 9.12917 4.4169L12.7325 4.7511C13.082 4.78352 13.2233 5.21824 12.9596 5.4499L10.2408 7.83828C10.1308 7.93491 10.0824 8.08391 10.1146 8.22674L10.9103 11.757C10.9875 12.0994 10.6177 12.3681 10.3158 12.1889L7.20422 10.3413C7.07833 10.2665 6.92167 10.2665 6.79578 10.3413L3.68416 12.1889C3.38235 12.3681 3.01255 12.0994 3.08972 11.757L3.88538 8.22674C3.91757 8.08391 3.86915 7.93491 3.75916 7.83828L1.04042 5.4499C0.776716 5.21824 0.917966 4.78352 1.26747 4.7511L4.87083 4.4169C5.01662 4.40338 5.14337 4.31129 5.20127 4.17682L6.63262 0.853097Z"
              fill="white"
            />
          </svg>

          Most popular
        </div>
      </div>

      <div class="price__text" v-text="card.description"></div>
      <div class="price__cost flex flex--column">
        <div class="price__label"></div>
        <div class="price__cost-wrap flex flex--align-center">
          <template v-if="typeof price === 'number'">
            <span class="price__cost-from" v-if="card.title === 'Enterprise'"
              >From</span
            >
            <s
              class="price__cost-amount-old"
              v-if="card.title === 'Business' && opts.mode === 'annual'"
              >{{ opts?.currency.split(" ")[0] }}{{ price_old }}</s
            >
            {{ opts?.currency.split(" ")[0] }}
            <span class="price__cost-amount">{{ Math.ceil(price) }}</span
            ><span class="price__cost-time">/month</span>
          </template>
          <template v-else>
            <span class="text">{{ price }}</span>
          </template>
        </div>
        <a
          href=""
          class="price__cost-save-annual"
          v-if="card.title === 'Business' && opts.mode === 'monthly'"
          @click.prevent="handleMode('annual')"
          >Save {{ opts?.currency.split(" ")[0] }}{{ Math.floor(price) }} by
          paying annually<svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.36396 1.63606L8.65685 0.928955L7.24264 2.34317L7.94975 3.05028L11.8995 7H1H0V9H1H11.8995L7.94975 12.9498L7.24264 13.6569L8.65685 15.0711L9.36396 14.364L15.0208 8.70713L15.7279 8.00002L15.0208 7.29292L9.36396 1.63606Z"
              fill="currentColor"
            ></path>
          </svg>
        </a>
        <span v-if="card.title === 'Business' && opts.mode === 'annual'"
          >Billed annually at {{ opts?.currency.split(" ")[0]
          }}{{ price_annualy }}
        </span>

        <div
          class="price__label"
          :style="isDollar ? { color: 'transparent' } : {}"
          v-text="priceLabel"
        ></div>
      </div>
      <template v-if="storageAsObject">
        <div class="price__parameters">
          <slider-item
            @handle-storage="handleStorage"
            :item="config"
            :key="config.title"
            ref="sliderItems"
          />
          <a
            @click.prevent="handleScrollTo('#price-calculator')"
            :href="card.helpLink"
            v-if="card.helpText"
            v-text="card.helpText"
          ></a>
        </div>
      </template>
      <template v-else>
        <div class="price__parameters">
          <div class="price__parameters-placeholder">
            <span>{{ card.storage.split("GB")[0] }} GB</span>
            {{ card.storage.split("GB")[1] }}
          </div>
          <a
            @click.prevent="handleScrollTo('#price-calculator')"
            :href="card.helpLink"
            v-if="card.helpText"
            v-text="card.helpText"
          ></a>
        </div>
      </template>
      <a
        :href="card.link"
        class="price__action-link"
        v-if="card.title === 'Enterprise'"
        >{{ card.linkText
        }}<svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.36396 1.63606L8.65685 0.928955L7.24264 2.34317L7.94975 3.05028L11.8995 7H1H0V9H1H11.8995L7.94975 12.9498L7.24264 13.6569L8.65685 15.0711L9.36396 14.364L15.0208 8.70713L15.7279 8.00002L15.0208 7.29292L9.36396 1.63606Z"
            fill="currentColor"
          ></path>
        </svg>
      </a>

      <div class="price__action">
        <a
          :href="card.buttonLink"
          class="btn"
          :class="{ 'btn--primary': card.popular, 'btn--white': !card.popular }"
          >{{ card.buttonText }}</a
        >
      </div>
      <div class="price__features">
        <div class="price__features-title" v-text="card.featuresTitle"></div>
        <ul class="price__features-list">
          <li
            v-for="({ title: feature }, idx) in card.features"
            v-html="feature"
            :key="idx"
          ></li>
        </ul>
      </div>
    </template>
    <template v-else>
      <div class="flex">
        <div class="price__plan-head">
          <div class="price__plan-title">
            {{ card.title }}
            <div class="price__plan-popular" v-if="card.title === 'Business'">
              <svg
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.63262 0.853097C6.77145 0.530712 7.22855 0.530711 7.36738 0.853097L8.79873 4.17682C8.85664 4.31129 8.98338 4.40338 9.12917 4.4169L12.7325 4.7511C13.082 4.78352 13.2233 5.21824 12.9596 5.4499L10.2408 7.83828C10.1308 7.93491 10.0824 8.08391 10.1146 8.22674L10.9103 11.757C10.9875 12.0994 10.6177 12.3681 10.3158 12.1889L7.20422 10.3413C7.07833 10.2665 6.92167 10.2665 6.79578 10.3413L3.68416 12.1889C3.38235 12.3681 3.01255 12.0994 3.08972 11.757L3.88538 8.22674C3.91757 8.08391 3.86915 7.93491 3.75916 7.83828L1.04042 5.4499C0.776716 5.21824 0.917966 4.78352 1.26747 4.7511L4.87083 4.4169C5.01662 4.40338 5.14337 4.31129 5.20127 4.17682L6.63262 0.853097Z"
                  fill="white"
                />
              </svg>

              Most popular
            </div>
          </div>
          <div class="price__text" v-text="card.description"></div>
        </div>

        <div class="price__cost flex flex--column">
          <div class="price__cost-wrap flex flex--align-center">
            <template v-if="typeof price === 'number'">
              <span v-if="card.title === 'Enterprise'">From</span>
              {{ opts?.currency.split(" ")[0] }}
              <span class="price__cost-amount">{{ Math.ceil(price) }}</span
              ><span class="price__cost-time">/month</span>
            </template>
            <template v-else>
              <span class="text">{{ price }}</span>
            </template>
          </div>
          <a
            href=""
            class="price__cost-save-annual"
            v-if="card.title === 'Business' && opts.mode === 'monthly'"
            @click.prevent="handleMode('annual')"
            >Save {{ opts?.currency.split(" ")[0] }}{{ Math.floor(price) }} by
            paying annually<svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.36396 1.63606L8.65685 0.928955L7.24264 2.34317L7.94975 3.05028L11.8995 7H1H0V9H1H11.8995L7.94975 12.9498L7.24264 13.6569L8.65685 15.0711L9.36396 14.364L15.0208 8.70713L15.7279 8.00002L15.0208 7.29292L9.36396 1.63606Z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
          <span v-if="card.title === 'Business' && opts.mode === 'annual'"
            >Billed annually at {{ opts?.currency.split(" ")[0]
            }}{{ price_annualy }}
          </span>
        </div>
      </div>
      <div class="price__plan-body flex flex--column">
        <template v-if="storageAsObject">
          <div class="price__parameters">
            <slider-item
              @handle-storage="handleStorage"
              :item="config"
              :key="config.title"
              ref="sliderItems"
            />
            <a
              @click.prevent="handleScrollTo('#price-calculator')"
              :href="card.helpLink"
              v-if="card.helpText"
              v-text="card.helpText"
            ></a>
          </div>
        </template>
        <template v-else>
          <div class="price__parameters">
            <div class="price__parameters-placeholder">
              {{ card.storage }}
            </div>
            <a
              @click.prevent="handleScrollTo('#price-calculator')"
              :href="card.helpLink"
              v-if="card.helpText"
              v-text="card.helpText"
            ></a>
          </div>
        </template>
        <div class="price__action">
          <a
            :href="card.buttonLink"
            class="btn"
            :class="{
              'btn--primary': card.popular,
              'btn--white': !card.popular,
            }"
            v-text="card.buttonText"
          ></a>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import settings from "@/assets/settings";
import SliderItem from "./SliderItem";

export default {
  name: "baseCard",
  components: { SliderItem },
  props: ["card", "opts"],
  inject: ["rootMedia", "handleMode"],
  data() {
    return {
      storage: 0,
      transfer: 0,
      showSelect: false,
      item: null,
      calculator: null,
    };
  },
  mounted() {
    this.handleStorage();
  },
  created() {
    this.calculator = window.Calculator;
    this.item = window[this.card.title];
    this.selected = this.storageAsObject
      ? Object.keys(this.card.storage)[0]
      : this.card.storage;
  },
  computed: {
    config() {
      return settings[1];
    },
    storageAsObject() {
      return (
        typeof this.card.storage === "object" &&
        Object.keys(this.card.storage).length
      );
    },
    media() {
      return this.rootMedia();
    },
    rates() {
      return this.calculator.rates[this.opts?.currency.split(" ")[1]].toFixed(
        1
      );
    },
    selected: {
      get() {
        return this.item;
      },
      set(val) {
        this.item.select = val;
      },
    },
    priceLabel() {
      if (this.card.priceLabel) {
        if (this.card.priceLabelSum) {
          let sum = Math.ceil(this.card.priceLabelSum * this.rates);

          return `${this.opts?.currency.split(" ")[0]}${sum} ${
            this.card.priceLabel
          }`;
        }

        return this.card.priceLabel;
      }

      return "";
    },
    isDollar() {
      return this.opts?.currency === "$ USD";
    },
    price() {
      if (this.storageAsObject) {
        if (!this.selected.select) return 0;
        return this.opts.mode === "monthly"
          ? Math.ceil(
              this.card.storage[this.selected.select][this.opts.mode] *
                this.rates
            )
          : this.card.storage[this.selected.select][this.opts.mode] *
              this.rates;
      }

      return this.card.price[this.opts.mode];
    },
    price_old() {
      if (this.storageAsObject) {
        if (!this.selected.select) return 0;
        return Math.ceil(
          this.card.storage[this.selected.select]["monthly"] * this.rates
        );
      }

      return this.card.price["monthly"];
    },
    price_annualy() {
      if (this.storageAsObject) {
        if (!this.selected.select) return 0;
        return this.opts.mode === "monthly"
          ? Math.ceil(
              this.card.storage[this.selected.select]["annual"] *
                this.rates *
                12
            )
          : Math.round(
              this.card.storage[this.selected.select][this.opts.mode] *
                this.rates *
                12
            ).toLocaleString();
      }

      return this.card.price["annual"] * 12;
    },
    formattedPrice() {
      return this.price.toString().split(".");
    },
  },

  methods: {
    handleScrollTo(selector) {
      let element = document.querySelector(selector);
      element.scrollIntoView({ behavior: "smooth" });
    },

    handleCloseSelect(e) {
      this.showSelect = false;
    },

    handleSelect(val) {
      this.selected = val;
    },
    handleStorage() {
      if (this.$refs.sliderItems) {
        let { input } = this.$refs.sliderItems.storage;
        this.selected = input + ` GB storage`;
      }
    },
  },

  watch: {
    selected: {
      handler(val) {
        this.calculator.handleTableData(this.card.title, {
          select: val.select,
          price: Math.ceil(this.price),
          transfer: !this.storageAsObject
            ? null
            : this.card.storage[val.select]["Data transfer limit"],
        });
      },
      deep: true,
    },
    opts: {
      handler(val) {
        this.calculator.handleTableData(this.card.title, {
          select: this.selected.select,
          price: Math.ceil(this.price),
          transfer: !this.storageAsObject
            ? null
            : this.card.storage[this.selected.select]["Data transfer limit"],
        });
      },
      deep: true,
    },
  },

  beforeDestroy() {
    window.removeEventListener("click", this.handleCloseSelect);
  },
};
</script>
<style lang="scss" scoped></style>
